import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function CeilingTraysContainerMenu() {
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="ceilingTray" />
    </SceneMenuContent>
  );
}
